import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import ReactTooltip from 'react-tooltip';

function ImageGridUpload({ setSelectedImg, file, removerImagem, setImagemPrincipal }) {
  const imagemVeiculo = file.base64Veiculo ? file.base64Veiculo : file.urlImagem;
  const [principal, setPrincipal] = useState(false);

  useEffect(() => {
    setPrincipal(file.principal);
  }, [principal]);

  const selecionarFile = (arq) => {
      setImagemPrincipal(arq);
  }

  return (
    <div key={file.hash} style={{ display: 'inline-block', marginLeft: 10}}>
      <span className="align-self-center tooltip-info">
        <div className="tooltip-ut">
          <ReactTooltip className="tooltip-ut" id={imagemVeiculo}
            type="dark" effect="solid">
            <div className="row">Clique para expandir.</div>
          </ReactTooltip>
        </div>
      </span>      
      <label htmlFor={`${file.hash}-${file.nome}`}> <input type="radio" id={`${file.hash}-${file.nome}`} name="imagemPrincipal" onChange={() => selecionarFile(file)} value={file.principal} checked={file.principal} /> {file.nome}</label>
      <motion.div
        layout
        data-toggle="tooltip"
        data-tip
        data-for={imagemVeiculo}
        className="img-wrap profile"        
        style={{ cursor: 'pointer' }}
        onClick={() => setSelectedImg(imagemVeiculo)}
      >
        <motion.img
          src={imagemVeiculo}
          alt={file.nome}
        />
      </motion.div>
      <button type="button" className="btn btn-editar"
        title='Remover'
        onClick={() => removerImagem(file)}>
        <i className="material-icons nav-icon" style={{
          fontSize: 18,
          color: 'red'
        }}>&#xe5cd;</i></button><br />
    </div>
  );
}

export default ImageGridUpload;
